<div>
    <sib-top-section></sib-top-section>
</div>
<!-- <div class="middle-section-container">
    <sib-middle-section></sib-middle-section>
</div> -->